import { Injectable } from '@angular/core';
import { GET, IRestFunc, Rest, RestResource } from '../../http/RestResource';
import { InjectionBundle } from '../../http/InjectionBundle';
import { TenantService } from '../../tenancy/service/tenant.service';

@Injectable()
@Rest({
	name: 'Image',
	pathPrefix: '/api/v1/images',
})
export class ImageResource extends InjectionBundle {
	@RestResource({
		method: GET,
		path: '/{imageId}',
	})
	get!: IRestFunc<string, { imageId: string } & { ['tenant-id']?: string }>;

	constructor(tenantService: TenantService) {
		super(tenantService);
	}
}
